import React from "react";
import * as LucideIcons from "lucide-react";
import { ILucideIcon } from "Interfaces/interface.uiUtils";

const DEFAULT_SIZE = 24;
const DEFAULT_STROKE = 1.6;

const LucideIcon: React.FC<ILucideIcon> = ({
  name,
  size = DEFAULT_SIZE,
  strokeWidth = DEFAULT_STROKE,
  className = "",
  ...props
}) => {
  const IconComponent = LucideIcons[name] as React.ElementType;
  if (!IconComponent) return null;

  const baseColorClass = "text-indigo-400 hover:text-indigo-600 hover:scale-10";

  return (
    <IconComponent
      className={`w-[${size}px] h-[${size}px] ${baseColorClass} ${className}`}
      strokeWidth={strokeWidth}
      {...props}
    />
  );
};

export default LucideIcon;
